// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__oPirN","question":"Question_question__1bzZP","description":"Question_description__oro5C"};